import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 15.633l-5.061-3.036a2.944 2.944 0 000-1.195L20 8.365v7.268zm-16 0V8.365l5.061 3.037a2.934 2.934 0 000 1.195L4 15.633zm17.228-9.436a1.529 1.529 0 00-1.535.02l-5.795 3.477A2.972 2.972 0 0012 8.999c-.725 0-1.38.268-1.898.696L4.306 6.217a1.527 1.527 0 00-1.534-.02A1.53 1.53 0 002 7.524v8.95a1.52 1.52 0 002.307 1.306l5.795-3.475a2.971 2.971 0 001.898.694c.725 0 1.38-.267 1.898-.695l5.796 3.477A1.52 1.52 0 0022 16.475V7.524a1.53 1.53 0 00-.772-1.327z"
    />
  </svg>
);
